import {
    FETCH_WEBVIEW_ORDERDETAILS,
    SHOW_RETURNS_LOADER,
    WEB_GET_RETURNS_COMPLETE,
    WEB_GET_RETURNS_LINE_ITEMSREQUEST,
    WEB_GET_RETURNS_LINE_ITEMSREQUEST_SUCCESS,
} from 'yoda-site-components/lib/actionTypes/NativeAppActionTypes';
import { call, takeLatest, put, race, delay, take, all, select } from 'redux-saga/effects';
import { getReturnsLineItems } from 'yoda-site-components/lib/actions/NativeAppAction';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { postMarketPlaceReturn } from 'yoda-interfaces/lib/Order/OrderApi';
import { get } from 'lodash';
import { formatReturnsLineItem } from '../helpers/Utils';
import {
    SUBMIT_MARKETPLACE_RETURN,
    SUBMIT_MARKETPLACE_RETURN_FAILURE,
    SUBMIT_MARKETPLACE_RETURN_SUCCESS,
} from '../actionTypes/MarketplaceReturnActionTypes';
import { MKTPLC_CONFIRM_RETURNS_ANALYTICS_ACTION } from '../actionTypes/MyOrdersActionTypes';

function* setWebviewReturnsLineItemsSaga(action) {
    const { payload } = action;
    if (payload?.lineItems) {
        const formattedLineItems = yield call(
            formatReturnsLineItem,
            payload?.lineItems,
            payload?.returns
        );
        yield put({
            type: WEB_GET_RETURNS_LINE_ITEMSREQUEST_SUCCESS,
            payload: { ...payload, lineItems: formattedLineItems },
        });
    }
}

function* getWebviewOrderDetails() {
    yield all([put({ type: SHOW_RETURNS_LOADER, payload: true }), put(getReturnsLineItems())]);
    const { response, timeout } = yield race({
        response: take(WEB_GET_RETURNS_LINE_ITEMSREQUEST),
        timeout: delay(10000),
    });
    yield put({ type: SHOW_RETURNS_LOADER, payload: false });
    if (response) {
        yield call(setWebviewReturnsLineItemsSaga, response);
    } else if (timeout) {
        // log the its been timedout if needed
    }
}

function* submitMarketPlaceReturns(action) {
    const { payload } = action;
    yield put({ type: 'SHOW_RETURNS_LOADER', payload: true });
    const result = yield call(FactorySaga, postMarketPlaceReturn, { payload });
    yield put({ type: 'SHOW_RETURNS_LOADER', payload: false });
    const isNative = yield select((state) => get(state, 'context.isNative', false));
    if (result?.isSuccess) {
        yield put({
            type: MKTPLC_CONFIRM_RETURNS_ANALYTICS_ACTION,
            payload: { eventName: 'confirmreturn:mp' },
        });
        const payload = {
            isReturnSuccess: true,
            returnSuccess: result?.response.data,
        };
        yield put({ type: SUBMIT_MARKETPLACE_RETURN_SUCCESS, payload });
        if (isNative) {
            yield put({
                type: WEB_GET_RETURNS_COMPLETE,
                payload: {
                    data: {
                        title: 'Return Request Submitted',
                        status: true,
                        didUserTapClosed: false,
                    },
                },
            });
        }
    } else {
        const payload = {
            isReturnError: true,
            returnError: result?.response?.data,
        };
        yield put({ type: SUBMIT_MARKETPLACE_RETURN_FAILURE, payload });
        if (isNative) {
            yield put({
                type: WEB_GET_RETURNS_COMPLETE,
                payload: { data: { title: '', status: false, didUserTapClosed: false } },
            });
        }
    }
}
function* watchMarketplaceReturnSaga() {
    yield takeLatest(FETCH_WEBVIEW_ORDERDETAILS, getWebviewOrderDetails);
    yield takeLatest(SUBMIT_MARKETPLACE_RETURN, submitMarketPlaceReturns);
}

watchMarketplaceReturnSaga.sagaName = 'marketplaceReturnSaga';
export default watchMarketplaceReturnSaga;
